





































































import { REQUEST_QRCODE } from "@/queries/user/mutation.graphql";
import Vue from "vue";
export default Vue.extend({
  data() {
    return {
      type: "generic",
      addTables: true,
      numberOfTables: 1,
      selectedColor: "primary",
      colors: ["primary", "gray", "info", "dark", "danger"],
      loading: false,
      success: null
    };
  },
  props: {
    open: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    close() {
      this.$emit("close");
      this.success = null;
    },
    async requestQrCode() {
      this.loading = true;
      const menuId = this.$store.getters["userModule/menuId"];
      const variables = { menuId };
      if (this.addTables) {
        variables["tablesNumber"] = this.numberOfTables;
      }
      const {
        data: { requestQrCodes },
        errors
      } = await this.$apollo.mutate({
        mutation: REQUEST_QRCODE,
        variables
      });
      this.loading = false;
      if (requestQrCodes.affected_rows) {
        this.success = true;
      }
    }
  }
});
